import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import App from "./App";
import * as jsPDF from "jspdf";
import firebase from "../firebase.js";
Vue.prototype.$firebase = firebase;

import Editor from "vue-editor-js";
import router from "./router";
import { store } from "./store";

import VueApexCharts from "vue-apexcharts";
import "@mdi/font/css/materialdesignicons.css";
import * as VueGoogleMaps from "vue2-google-maps";

import DateFilter from "./filters/date";
import UserFilter from "./filters/user";
import MoneyFilter from "./filters/money";

// Import Module
import uebersicht from "./module/uebersicht.vue";
import veranstaltungen from "./module/veranstaltungen.vue";
import todo from "./module/todo.vue";
import rechnungen from "./module/rechnungen.vue";
import kassenbuch from "./module/kassenbuch.vue";
import kontobuch from "./module/kontobuch.vue";
import dateien from "./module/dateien.vue";
import kontakte from "./module/kontakte.vue";
import lexikon from "./module/lexikon.vue";
import ahnengalerie from "./module/ahnengalerie.vue";
import wirtschaftsplan from "./module/wirtschaftsplan.vue";
import couleurstrafen from "./module/couleurstrafen.vue";
import mail from "./module/mail.vue";
import dokumente from "./module/dokumente.vue";
import zirkel from "./module/zirkel.vue";

// Import Module Bierwart
import bierwartBierlieferungen from "./module/bierwartBierlieferungen.vue";
import bierwartGetranke from "./module/bierwartGetranke.vue";
import bierwartGetrankeZahlen from "./module/bierwartGetrankeZahlen.vue";
import bierwartSchankverlust from "./module/bierwartSchankverlust.vue";
import bierwartStriche from "./module/bierwartStriche.vue";
import bierwartVeranstaltung from "./module/bierwartVeranstaltung.vue";
import bierwartVeranstaltungAbrechnen from "./module/bierwartVeranstaltungAbrechnen.vue";

// Import Submodule
import einstellungen from "./module/einstellungenComponents/einstellungen.vue";
import todoSeite from "./module/submodule/todoSeite.vue";
import stricheNeu from "./module/submodule/stricheNeu.vue";
import dialogRechnung from "./module/submodule/dialogRechnung.vue";
import dialogRechnungenVersenden from "./module/submodule/dialogRechnungenVersenden.vue";
import dialogVeranstaltung from "./module/submodule/dialogVeranstaltung.vue";
import dialogVeranstaltungEdit from "./module/submodule/dialogVeranstaltungEdit.vue";
import dialogDelete from "./module/submodule/dialogDelete.vue";
import dialogKontakt from "./module/submodule/dialogKontakt.vue";
import dialogKontaktCreate from "./module/submodule/dialogKontaktCreate.vue";
import dialogKontaktEdit from "./module/submodule/dialogKontaktEdit.vue";
import dialogKontaktEditMultiple from "./module/submodule/dialogKontaktEditMultiple.vue";
import dialogMail from "./module/submodule/dialogMail.vue";
import dialogMailNeu from "./module/submodule/dialogMailNeu.vue";
import dialogSendKontaktData from "./module/submodule/dialogSendKontaktData.vue";
import RechnungenListe from "./module/submodule/rechnungenListe.vue";
import rowWirtschaftsplan from "./module/submodule/rowWirtschaftsplan.vue";

// Import kleine Module
import chargen from "./module_klein/chargen.vue";
import geburtstage from "./module_klein/geburtstage.vue";
import jubilaum from "./module_klein/jubilaum.vue";
import kontakteStatus from "./module_klein/kontakteStatus.vue";
import mailsListe from "./module_klein/mailsListe.vue";
import rechnungenEigene from "./module_klein/rechnungenEigene.vue";
import rechnungenStatus from "./module_klein/rechnungenStatus.vue";
import ripuaren from "./module_klein/ripuaren.vue";
import todosEigene from "./module_klein/todosEigene.vue";
import veranstaltungenListe from "./module_klein/veranstaltungenListe.vue";
import bundesbruderSuche from "./module_klein/bundesbruderSuche.vue";
import bundesbruderSucheShort from "./module_klein/bundesbruderSucheShort.vue";
import bierranking from "./module_klein/bierranking.vue";
import schankverlust from "./module_klein/schankverlust.vue";
import rechnungSuche from "./module_klein/rechnungSuche.vue";
import keilkandidaten from "./module_klein/keilkandidaten.vue";

// Import Components
import buttonRechnungDownload from "./components/button/rechnungDownload.vue";
import buttonRechnungSenden from "./components/button/rechnungSenden.vue";
import uiKontaktField from "./components/ui/kontaktfield.vue";

const opts = {
  defaults: {
    VBtn: {
      style: "text-transform: none;",
    },
  },
  theme: {
    icons: {
      iconfont: "mdi",
    },
    themes: {
      light: {
        // primary: '#0C4E7D', // 160 jahre blau
        primary: "#254fb3", // original blau
        secondary: "#DB1F29", // #FFCDD2
        accent: "#ce122c", // #3F51B5
      },
      dark: {
        primary: "#254fb3", // #E53935
        secondary: "#DB1F29", // #FFCDD2
        accent: "#ce122c", // #3F51B5
      },
    },
  },
};

Vue.use(Editor);
Vue.use(Vuetify);
Vue.use(jsPDF);
Vue.config.productionTip = false;
Vue.use(VueApexCharts);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC6Swg9H5SoioL2ixvT5mgmM9P0blsmUuI",
    // libraries: 'places'
    region: "DE",
    language: "de",
  },
});

Vue.filter("date", DateFilter);
Vue.filter("user", UserFilter);
Vue.filter("money", MoneyFilter);

Vue.component("apexchart", VueApexCharts);

// Component Module
Vue.component("einstellungen", einstellungen);
Vue.component("uebersicht", uebersicht);
Vue.component("veranstaltungen", veranstaltungen);
Vue.component("todo", todo);
Vue.component("rechnungen", rechnungen);
Vue.component("kassenbuch", kassenbuch);
Vue.component("kontobuch", kontobuch);
Vue.component("dateien", dateien);
Vue.component("kontakte", kontakte);
Vue.component("lexikon", lexikon);
Vue.component("ahnengalerie", ahnengalerie);
Vue.component("wirtschaftsplan", wirtschaftsplan);
Vue.component("couleurstrafen", couleurstrafen);
Vue.component("mail", mail);
Vue.component("dokumente", dokumente);
Vue.component("zirkel", zirkel);

// Component Module Bierwart
Vue.component("bierwartBierlieferungen", bierwartBierlieferungen);
Vue.component("bierwartGetranke", bierwartGetranke);
Vue.component("bierwartGetrankeZahlen", bierwartGetrankeZahlen);
Vue.component("bierwartSchankverlust", bierwartSchankverlust);
Vue.component("bierwartStriche", bierwartStriche);
Vue.component("bierwartVeranstaltung", bierwartVeranstaltung);
Vue.component("bierwartVeranstaltungAbrechnen", bierwartVeranstaltungAbrechnen);

// Component Submodule
Vue.component("todoSeite", todoSeite);
Vue.component("stricheNeu", stricheNeu);
Vue.component("dialogRechnung", dialogRechnung);
Vue.component("dialogRechnungenVersenden", dialogRechnungenVersenden);
Vue.component("dialogVeranstaltung", dialogVeranstaltung);
Vue.component("dialogVeranstaltungEdit", dialogVeranstaltungEdit);
Vue.component("dialogDelete", dialogDelete);
Vue.component("dialogKontakt", dialogKontakt);
Vue.component("dialogKontaktCreate", dialogKontaktCreate);
Vue.component("dialogKontaktEdit", dialogKontaktEdit);
Vue.component("dialogKontaktEditMultiple", dialogKontaktEditMultiple);
Vue.component("dialogMail", dialogMail);
Vue.component("dialogMailNeu", dialogMailNeu);
Vue.component("dialogSendKontaktData", dialogSendKontaktData);
Vue.component("rechnungen-liste", RechnungenListe);
Vue.component("rowWirtschaftsplan", rowWirtschaftsplan);

// Component Kleine Module
Vue.component("chargen", chargen);
Vue.component("geburtstage", geburtstage);
Vue.component("jubilaum", jubilaum);
Vue.component("kontakteStatus", kontakteStatus);
Vue.component("mailsListe", mailsListe);
Vue.component("rechnungenEigene", rechnungenEigene);
Vue.component("rechnungenStatus", rechnungenStatus);
Vue.component("ripuaren", ripuaren);
Vue.component("todosEigene", todosEigene);
Vue.component("veranstaltungenListe", veranstaltungenListe);
Vue.component("bundesbruderSuche", bundesbruderSuche);
Vue.component("bundesbruderSucheShort", bundesbruderSucheShort);
Vue.component("bierranking", bierranking);
Vue.component("schankverlust", schankverlust);
Vue.component("rechnungSuche", rechnungSuche);
Vue.component("keilkandidaten", keilkandidaten);

// Component Components
Vue.component("buttonRechnungDownload", buttonRechnungDownload);
Vue.component("buttonRechnungSenden", buttonRechnungSenden);
Vue.component("uiKontaktField", uiKontaktField);

// Rekursives Laden aller Komponenten im "components"-Verzeichnis und seinen Unterordnern
const requireComponent = require.context("./components", true, /.*\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");

  Vue.component(componentName, componentConfig.default || componentConfig);
});

window.bus = new Vue();

// ****************************************************************
// Import globale Variablen und Funktionen
// **********************firebase******************************************
import { sumArray, getCurrentBbr, selectLeibvater } from "./main_funktionen.js";
Vue.prototype.$sumArray = sumArray;
Vue.prototype.$getCurrentBbr = getCurrentBbr;
Vue.prototype.$selectLeibvater = selectLeibvater;

import vars from "./main_variablen.js";
Vue.prototype.$vars = vars;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  vuetify: new Vuetify(opts),
  router,
  store,
  render: (h) => h(App),
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // Debug Problem Koppelberg
        if (this.$vars.beta) {
          // console.log('----------------------')
          // console.log('Debug')
          // console.log('CurrentUser: ' + this.$firebase.auth().currentUser.uid)
          // console.log('CurrentMail: ' + this.$firebase.auth().currentUser.email)
          // console.log('CurrentUser verified: ' + this.$firebase.auth().currentUser.emailVerified)
          // console.log('CurrentUser Last Log In: ' + this.$firebase.auth().currentUser.metadata.lastSignInTime)
          // console.log('Debug End')
          // console.log('----------------------')
        }
        this.$store.dispatch("user/autoSignIn", user);
      }
      if (firebase.auth().currentUser.emailVerified) {
        this.$store.dispatch("bbrbbr/loadBbrBbr");
        this.$store.dispatch("bbrbbr/loadEinstellungen");
        this.$store.dispatch("mails/loadKassen");
        this.$store.dispatch("mails/loadBbrBbr");
        this.$store.dispatch("mails/loadVeranstaltungen");
        this.$store.dispatch("mails/loadEinstellungen");
        this.$store.dispatch("news/loadNews");
        this.$store.dispatch("einstellungen/loadEinstellungen");
        this.$store.dispatch("vereine/loadVereine");
        // this.$store.dispatch('kassenbucher/loadKassenbucher')
        // this.$store.dispatch('wirtschaftsplane/loadWirtschaftsplane')
      }
    });
    Vue.prototype.$messaging = firebase.messaging();
    // Globale Funktion definieren
    Vue.prototype.$filters = {
      money(value) {
        const formatter = Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        });
        return formatter.format(value);
      },

      user(contact, contacts) {
        const a = contacts.find((item) => item.id === contact);
        return a ? a.nachname + ", " + a.vorname : contact;
      },

      date(value, format = "DD.MM.YYYY hh:mm:ss") {
        const date = new Date(value);
        if (isNaN(date)) {
          return "-";
        }

        // Zerlege das Datum in seine Bestandteile
        const day = String(date.getDate());
        const month = String(date.getMonth() + 1);
        const year = String(date.getFullYear());
        const shortYear = String(date.getFullYear()).slice(2);

        // Zerlege die Uhrzeit in ihre Bestandteile
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        // Arrays für Wochentage und Monate in Deutsch
        const weekdaysShort = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
        const weekdaysLong = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
        const monthsShort = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
        const monthsLong = [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ];

        // Bestimme den Wochentag und Monat als Index
        const weekdayIndex = date.getDay();
        const monthIndex = date.getMonth();

        // Ersetze die Platzhalter im Format-String
        return format
          .replace("DDDD", weekdaysLong[weekdayIndex])
          .replace("DDD", weekdaysShort[weekdayIndex])
          .replace("DD", day.padStart(2, "0"))
          .replace("MMMM", monthsLong[monthIndex])
          .replace("MMM", monthsShort[monthIndex])
          .replace("MM", month.padStart(2, "0"))
          .replace("YYYY", year)
          .replace("YY", shortYear)
          .replace("hh", hours)
          .replace("mm", minutes)
          .replace("ss", seconds);
      },
    };

    // navigator.serviceWorker.register('/static/firebase-messaging-sw.js')
    //   .then((registration) => {
    //     Vue.prototype.$messaging.useServiceWorker(registration)
    //   }).catch(err => {
    //     console.log(err)
    //   })
  },
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js